import styled from '@emotion/styled'

export const FooterImageDiv = styled.div`
    label: FooterImageDiv;
    width: 100%;
    min-height: 125px;
    display: flex;
    justify-content: left;
    /* background-image: url('images/car_with_line.png'); */
    /* background-position: right;
    background-repeat: no-repeat; */
    @media (max-width: 719px) {
        /* background-image: none; */
        justify-content:center;
    }
`

export const FooterImageContainer = styled('div')`
label: FooterImageContainer;
display:flex;
white-space:nowrap;

>img:last-child{
position:absolute;
right:0 ;
z-index:0;
@media (max-width: 719px) {
   display:none;
  }
}
>img:first-child{
position:absolute;
left:0 ;
z-index:1;
height:150px;
}

`